module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-analysis.52f12bcd.png";